import type { FaireReviewEntity } from "../../entity_types/review";

// Real per-product review for P.F. Candle Co.'s "Golden Coast - 7.2 oz
// Standard Candle" (p_28ocoknq), pulled from Faire's live
// `GET /api/product-reviews/product/{product_token}` endpoint — verbatim
// comment, real reviewer, real rating, real publish date.
export const review_pfc2: FaireReviewEntity = {
  token: "review_pfc2",
  type: "review",
  brandName: "P.F. Candle Co.",
  brandToken: "b_a9b3b023",
  productToken: "p_28ocoknq",
  reviewType: "product",
  reviewerName: "Loran Bohall",
  reviewerLocation: "Indianapolis, IN, United States",
  stars: 5,
  reviewText:
    "Smells great! We love this product for our new storefront in Indianapolis.",
  reviewDate: "Jul 28, 2023",
  meta: {
    source: "api",
    importedAt: "2026-08-11T20:49:30.000Z",
    importedBy: "entity-db-cli",
  },
};
